import React, { useEffect, useState } from "react";
import "./Reporting.scss";
import TableContainer from "../../components/TableContainer/TableContainer";
import { Box, Typography, Select, MenuItem, styled, Button, InputLabel, FormControl, Grid } from "@mui/material";
import {
  ListUsers,
  ListAgentAccounts,
} from "../../util/API/reporting";
import { debounce } from 'lodash';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format, parseISO } from "date-fns";
import { useSelector } from "react-redux";
import BaseButton from "../../components/UI/BaseButton/BaseButton";
import { commonRunQuery } from "../../util/API/loans";

function Reporting() {
  const [duration, setDuration] = useState(1);
  const [loansDuration, setLoansDuration] = useState(1);
  const [ATMDuration, setATMDuration] = useState(1);
  const [showDetails, setShowDetails] = useState(false);
  const [displayATMReport, setDisplayATMReport] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [loansStartDate, setLoansStartDate] = useState();
  const [loansEndDate, setLoansEndDate] = useState();
  const [atmStartDate, setATMStartDate] = useState();
  const [atmEndDate, setATMEndDate] = useState();
  const [filter, setFilter] = useState({
    user: "",
    type: "",
    viewAll: false,
    clearFilter: false
  });
  const [loansFilter, setLoansFilter] = useState({
    user: "",
    type: "6, 18",
    viewAll: false,
    clearFilter: false
  });
  const [atmFilter, setATMFilter] = useState({
    user: "0",
    type: "",
    viewAll: false,
    clearFilter: false
  });
  const [transactionType, setTransactionType] = useState({})
  const [currency, setCurrency] = useState("USD")
  const [options, setOptions] = useState({
    user: [],
    type: [],
  })
  const [atmOptions, setATMOptions] = useState({
    user: [],
    type: [],
  })
  const [fetchSummary, setFetchSummary] = useState(false)
  const [selectedReportType, setSelectedReportType] = useState(1)
  
  let isAdmin = sessionStorage.getItem("isAdmin");
  let isOperator = sessionStorage.getItem("isOperator");
  let isLoanAdmin = JSON.parse(sessionStorage.getItem("isLoanAdmin"));
  let isSuperAdmin = JSON.parse(sessionStorage.getItem("isSuperAdmin"));

  const requiredConstants = useSelector((state) => state.constants);

  let configVariables = useSelector((state) => state.config.baseConfig);
  const atmReportUsers = configVariables.atmReportUsers;
  
  console.log("atmReportUsers------------",atmReportUsers);
  // console.log("FiletrUser------------",filter?.user);
  // console.log("FiletrUser_options------------",options?.user);

  useEffect(() => {
    if (isAdmin) { 
      getUserOptions() 
    }
  }, [isAdmin]);

  useEffect(() => {
    const userRoles = JSON.parse(sessionStorage.getItem("userResponse"))
      ?.payload?.body?.Securityuserrole;
  
    const userRolesArray = Array.isArray(userRoles) ? userRoles : [userRoles];
  
    const userRoleIds = userRolesArray.map(role =>
      role?.roleid?.toString()
    );
  
    const atmReportUsersArray = atmReportUsers ? atmReportUsers.split(",").map(id => id.trim()) : [];
  
    const hasMatch = userRoleIds.some(roleId => atmReportUsersArray.includes(roleId));
  
    console.log("userRoleIds====", userRoleIds);
    console.log("atmReportUsersArray====", atmReportUsersArray);
    console.log("hasMatch====", hasMatch);
    setDisplayATMReport(hasMatch);
  
  }, [atmReportUsers]);

  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;
  
  const clearFilter = () => {
    setFilter({
      user: "",
      type: "",
      viewAll: false,
      clearFilter: true
    });
    setLoansFilter({
      user: "",
      type: "",
      viewAll: false,
      clearFilter: true
    });
    setATMFilter({
      user: "",
      type: "",
      viewAll: false,
      clearFilter: true
    });
    if (duration === "4") {
      const startdate = format(new Date(), "yyyy-MM-dd");
      const enddate = format(new Date(), "yyyy-MM-dd");
      setStartDate(startdate);
      setEndDate(enddate);
      setLoansStartDate(startdate);
      setLoansEndDate(enddate);
      setATMStartDate(startdate);
      setATMEndDate(enddate);
      
    }
  }

  const handleSelectChange = (e) => {
    setFilter({
      ...filter,
      viewAll: false
    })
    setDuration(e.target.value);
    setShowDetails(false);
  };

  const handleLoanDurationChange = (e) => {
    setLoansFilter({
      ...loansFilter,
      viewAll: false
    })
    setLoansDuration(e.target.value);
    setShowDetails(false);
  };

  const handleATMDurationChange = (e) => {
    setATMFilter({
      ...atmFilter,
      viewAll: false
    })
    setATMDuration(e.target.value);
    setShowDetails(false);
  };

  const handleReportChange = (e) => {
    setTransactionType({});
    setSelectedReportType(e.target.value);
  }

  const handleDetailSwitch = () => {
    setShowDetails(!showDetails);
  };

  const reportingTitle = {
    1: "Account Daily",
    2: "Account Weekly",
    3: "Account Monthly",
    4: "Account Custom",
  };

  const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
    border: "none",
    color: "#6B7280",
    fontFamily: "Nunito",
    fontSize: "14px",
    fontStyle: "normal",
    lineHeight: "33.6px",
    justifyContent: "left",
  }));

  const StyledDatePicker = styled(DatePicker)({
    borderRadius: "5px", 
    background: "white", 
    width: "120%", 
    height: "40px", 
    "& .MuiInputBase-input": {
      padding: "8px 12px", 
      fontSize: "16px", 
      fontFamily: "Nunito", 
      fontWeight: "600", 
      color: "#6B7280",
    },
    "& .MuiInputLabel-outlined": {
      color: "#6B7280", 
      fontSize: "14px", 
      fontFamily: "Nunito", 
      fontWeight: "400", 
      backgroundColor: "white", 
      padding: "0 5px", 
    },
  });

  const MemoizedDatePicker = React.memo((props) => <StyledDatePicker {...props} />);


  const StyledSelect = styled(Select)({
    borderRadius: "5px", 
    border: "1px solid #D7D7D7", 
    color: "#6B7280",
    fontFamily: "Nunito",
    fontSize: "16px",
    padding: "0px 10px",
    width: "200px",
    height: "40px",
    background: "white", 
    textAlign: "left", 
    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
    "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none" },
  });

  const StyledInputLabel = styled(InputLabel)({
    color: "#6B7280",
    fontFamily: "Nunito",
    fontSize: "16px",
    background: "white",
    padding: "0 5px",
    lineHeight: "1.2",
    top: "-4px", 
    "&.Mui-focused": {
      color: "#145388",
    },
    "&.MuiInputLabel-shrink": {
      top: "2px"
    },
  });

  async function getTransactionOptions() {
    let transactionOptions = requiredConstants.transactionTypes.map((transaction) => {
      return {
        key: transaction.Vtranstype.typeID,
        value: transaction.Vtranstype.typeID,
        label: transaction.Vtranstype.label,
    }});

    transactionOptions.unshift({
      key: "alltransactions",
      value: 0,
      label: "All Transactions", 
    })

    setOptions((prevOptions) => ({
      ...prevOptions,
      type: transactionOptions,
    }));
  }


  async function getUserOptions() {
    let user
    let userOptions

    if (isAdmin === "true") {
      user = await ListAgentAccounts()
      console.log(user)

      userOptions = Array.isArray(user?.payload?.record)
      ? user?.payload?.record.map((agent) => {
          return {
            key: agent?.merchant?.userid,
            value: agent?.merchant?.userid,
            label: agent?.merchant?.businessname,
          };
        })
      : [];
    }
    else {
      user = await ListUsers(
        agent['User']?.id, // agent
      );

      console.log(user)

      userOptions = Array.isArray(user?.payload?.data?.VusersubacctRecs)
      ? user?.payload?.data?.VusersubacctRecs.map((user) => {
          return {
            key: user?.Vusersubacct?.subacctid,
            value: user?.Vusersubacct?.subacctid,
            label: user?.Vusersubacct?.firstName + " " + user?.Vusersubacct?.lastName,
          };
        })
      : user?.payload?.data?.VusersubacctRecs
      ? [
          {
            key: user?.payload?.data?.VusersubacctRecs?.Vusersubacct?.subacctid,
            value: user?.payload?.data?.VusersubacctRecs?.Vusersubacct?.subacctid,
            label:
              user?.payload?.data?.VusersubacctRecs?.Vusersubacct?.firstName +
              " " +
              user?.payload?.data?.VusersubacctRecs?.Vusersubacct?.lastName,
          },
        ]
      : [];
    }

      if (isAdmin === "false" && isOperator === "false") {
        userOptions.unshift({
          key: "allagents",
          value: "allagents",
          label: "All Clerks",
        });
      }
      else if (isAdmin === "true") {
        userOptions.unshift({
          key: "allagents",
          value: "allagents",
          label: "All Agents",
        });
      }

      userOptions.unshift({
        key: agent['User'].id,
        value: agent['User'].id,
        label: agent['User'].firstName + " " + agent['User'].lastName,
      });

      console.log(userOptions)

    setOptions((prevOptions) => ({
      ...prevOptions,
      user: userOptions,
    }));
    console.log(options)
  }

  useEffect(() => {
    getTransactionOptions();
  }, []);

  useEffect(()=> {
    if(selectedReportType == '3') {
      getATMList();
    }
    setShowDetails(false);

    setATMFilter({ ...atmFilter, type: "" });
    setTransactionType({});
  }, [selectedReportType])

  const getATMList = async() => {
    const response = await commonRunQuery(356, "");
    console.log("getATMList========",response);
    if(response?.data?.header?.callStatus == "1") {
      let atmArr = response?.data?.body?.record;
      if (!Array.isArray(atmArr)) {
        atmArr = [atmArr];
      }

      let transactionOptions = atmArr?.map((transaction, id) => {
        return {
          key: id,
          value: transaction.domainattributes.attname,
          label: transaction.domainattributes.domainatt,
      }});
  
      transactionOptions.unshift({
        key: "allatms",
        value: 0,
        label: "All ATM's", 
      })
      console.log("transactionOptions========",transactionOptions);
  
      setATMOptions((prevOptions) => ({
        ...prevOptions,
        user: transactionOptions,
      }));
    }

    const response2 = await commonRunQuery(357, "");
    if(response2?.data?.header?.callStatus == "1") {
      let transTypeArr = response2?.data?.body?.record;
      console.log("transTypeArr========",transTypeArr);
      if (!Array.isArray(transTypeArr)) {
        transTypeArr = [transTypeArr];
      }

      let transactionOptions = transTypeArr?.map((transaction, id) => {
        return {
          key: transaction.Vtranstype.typeID,
          value: transaction.Vtranstype.typeID,
          label: transaction.Vtranstype.label,
      }});

      transactionOptions.unshift({
        key: "alltransactions",
        value: 0,
        label: "All Transactions", 
      });

      setATMOptions((prevOptions) => ({
        ...prevOptions,
        type: transactionOptions,
      }));
    }

  }

  const formatDate = (date) => {
    console.log(date)
    if (!date) return ""; 
    let d = date instanceof Date ? date : new Date(`${date}T00:00`);
    console.log(d)
    const year = d.getFullYear();
    const month = d.getMonth() + 1; 
    const day = d.getDate(); 

    console.log(`${year}-${month < 10 ? "0" : ""}${month}-${day < 10 ? "0" : ""}${day}`)
  
    return `${year}-${month < 10 ? "0" : ""}${month}-${day < 10 ? "0" : ""}${day}`;
  };

  const handleStartDateChange = debounce((value) => {
    if (!value) return;
  
    const newStartDate = parseISO(value);
    const currentEndDate = endDate ? parseISO(endDate) : null;
  
    // If endDate is not set, make it same as start
    if (!currentEndDate) {
      setEndDate(formatDate(newStartDate));
    }
    // If date gap is more than 1 month, adjust endDate
    else if (currentEndDate.getTime() - newStartDate.getTime() > 31 * 24 * 60 * 60 * 1000) {
      const maxEnd = new Date(newStartDate);
      maxEnd.setMonth(maxEnd.getMonth() + 1);
      setEndDate(formatDate(maxEnd));
    }
  
    setStartDate(formatDate(newStartDate));
  }, 300);

  const handleLoanStartDateChange = debounce((value) => {
    if (!value) return;
  
    const newStartDate = parseISO(value);
    const currentEndDate = endDate ? parseISO(endDate) : null;
  
    // If endDate is not set, make it same as start
    if (!currentEndDate) {
      setLoansEndDate(formatDate(newStartDate));
    }
    // If date gap is more than 1 month, adjust endDate
    else if (currentEndDate.getTime() - newStartDate.getTime() > 31 * 24 * 60 * 60 * 1000) {
      const maxEnd = new Date(newStartDate);
      maxEnd.setMonth(maxEnd.getMonth() + 1);
      setLoansEndDate(formatDate(maxEnd));
    }
  console.log("newStartDate========",newStartDate);
    setLoansStartDate(formatDate(newStartDate));
  }, 300);

  const handleATMStartDateChange = debounce((value) => {
    if (!value) return;
  
    const newStartDate = parseISO(value);
    const currentEndDate = endDate ? parseISO(endDate) : null;
  
    // If endDate is not set, make it same as start
    if (!currentEndDate) {
      setATMEndDate(formatDate(newStartDate));
    }
    // If date gap is more than 1 month, adjust endDate
    else if (currentEndDate.getTime() - newStartDate.getTime() > 31 * 24 * 60 * 60 * 1000) {
      const maxEnd = new Date(newStartDate);
      maxEnd.setMonth(maxEnd.getMonth() + 1);
      setATMEndDate(formatDate(maxEnd));
    }
  console.log("newStartDate========",newStartDate);
    setATMStartDate(formatDate(newStartDate));
  }, 300);

  const handleEndDateChange = debounce((value) => {
    if (!value) return;
  
    const newEndDate = parseISO(value);
    const currentStartDate = startDate ? parseISO(startDate) : null;
  
    // If startDate is not set, make it same as end
    if (!currentStartDate) {
      setStartDate(formatDate(newEndDate));
    }
    // If date gap is more than 1 month, adjust startDate
    else if (newEndDate.getTime() - currentStartDate.getTime() > 31 * 24 * 60 * 60 * 1000) {
      const minStart = new Date(newEndDate);
      minStart.setMonth(minStart.getMonth() - 1);
      setStartDate(formatDate(minStart));
    }
  
    setEndDate(formatDate(newEndDate));
  }, 300);

  const handleLoansEndDateChange = debounce((value) => {
    if (!value) return;
  
    const newEndDate = parseISO(value);
    const currentStartDate = startDate ? parseISO(startDate) : null;
  
    // If startDate is not set, make it same as end
    if (!currentStartDate) {
      setLoansStartDate(formatDate(newEndDate));
    }
    // If date gap is more than 1 month, adjust startDate
    else if (newEndDate.getTime() - currentStartDate.getTime() > 31 * 24 * 60 * 60 * 1000) {
      const minStart = new Date(newEndDate);
      minStart.setMonth(minStart.getMonth() - 1);
      setLoansStartDate(formatDate(minStart));
    }
  
    setLoansEndDate(formatDate(newEndDate));
  }, 300);

  const handleATMEndDateChange = debounce((value) => {
    if (!value) return;
  
    const newEndDate = parseISO(value);
    const currentStartDate = startDate ? parseISO(startDate) : null;
  
    // If startDate is not set, make it same as end
    if (!currentStartDate) {
      setATMStartDate(formatDate(newEndDate));
    }
    // If date gap is more than 1 month, adjust startDate
    else if (newEndDate.getTime() - currentStartDate.getTime() > 31 * 24 * 60 * 60 * 1000) {
      const minStart = new Date(newEndDate);
      minStart.setMonth(minStart.getMonth() - 1);
      setATMStartDate(formatDate(minStart));
    }
  
    setATMEndDate(formatDate(newEndDate));
  }, 300);

  console.log("atmFilter===============",atmFilter);

  return (
    <Box className="page-container">
        <Box className="header-container" sx={{ display: "flex", justifyContent:"space-between" }}>
          <Box className={`page-title`}>
            Reporting
          </Box>
          <Box>
            <Box sx={{ marginRight: "auto"}}>
              <FormControl fullWidth>
                <InputLabel
                  id="select-view-label"
                  sx={{
                    color: "#6B7280",
                    fontFamily: "Nunito",
                    fontSize: "16px",
                    background: "white",
                    padding: "0 5px",
                  }}
                >
                  Select Reports
                </InputLabel>
                <Select
                  labelId="select-view-label"
                  name="selectView"
                  className="reporting-select"
                  onChange={handleReportChange}
                  value={selectedReportType}
                  sx={{
                    borderRadius: "5px", // Custom border radius
                    border: "1px solid #D7D7D7", // Your custom border
                    color: "#6B7280", // Text color
                    fontFamily: "Nunito", // Font family
                    fontSize: "16px", // Font size
                    padding: "0px 10px", // Adjust padding
                    width: "100%", // Width
                    height: "40px", // Height
                    background: "white", // Background color
                    textAlign: "left", // Align text to the left
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Removes the default border applied by Material-UI
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Ensures no border appears on hover
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Ensures no border appears on focus
                    },
                  }}
                >
                  <CustomMenuItem value="" disabled>
                    Reports
                  </CustomMenuItem>
                  <CustomMenuItem value="1">Admin Reports</CustomMenuItem>
                  {(isLoanAdmin || isSuperAdmin) ? <CustomMenuItem value="2">Loan Reports</CustomMenuItem> : null}
                  {displayATMReport ? <CustomMenuItem value="3">ATM Reports</CustomMenuItem> : null}
                </Select>
              </FormControl>
            </Box>
          </Box>
        </Box>
      <Box className="batch-tabs">
        {
          selectedReportType == '1' ? 
          <Box>
            <Box sx={{ backgroundColor: "#FFFFFF", padding: "10px", borderRadius: "8px" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "nowrap" }}>
              <Box sx={{ marginRight: "auto"}}>
                  <FormControl fullWidth>
                    <InputLabel
                      id="select-view-label"
                      sx={{
                        color: "#6B7280",
                        fontFamily: "Nunito",
                        fontSize: "16px",
                        background: "white",
                        padding: "0 5px",
                      }}
                    >
                      Select View
                    </InputLabel>
                    <Select
                      labelId="select-view-label"
                      name="selectView"
                      className="reporting-select"
                      onChange={handleSelectChange}
                      value={duration}
                      sx={{
                        borderRadius: "5px", // Custom border radius
                        border: "1px solid #D7D7D7", // Your custom border
                        color: "#6B7280", // Text color
                        fontFamily: "Nunito", // Font family
                        fontSize: "16px", // Font size
                        padding: "0px 10px", // Adjust padding
                        width: "100%", // Width
                        height: "40px", // Height
                        background: "white", // Background color
                        textAlign: "left", // Align text to the left
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none", // Removes the default border applied by Material-UI
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          border: "none", // Ensures no border appears on hover
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "none", // Ensures no border appears on focus
                        },
                      }}
                    >
                      <CustomMenuItem value="" disabled>
                        Reports
                      </CustomMenuItem>
                      <CustomMenuItem value="1">Account Daily</CustomMenuItem>
                      <CustomMenuItem value="2">Account Weekly</CustomMenuItem>
                      <CustomMenuItem value="3">Account Monthly</CustomMenuItem>
                      <CustomMenuItem value="4">Account Custom</CustomMenuItem>
                    </Select>
                  </FormControl>
                </Box>
                {/* User */}
                <Box sx={{ display: "flex", alignItems: "center", width: "200px" }}>
                  <FormControl fullWidth>
                  <StyledInputLabel
                    id="user-label"
                    sx={{
                      color: "#6B7280",
                      fontFamily: "Nunito",
                      fontSize: "16px",
                      background: "white",
                      padding: "0 5px",
                      lineHeight: "1.2", 
                      top: "-4px", 
                      "&.Mui-focused": { color: "#145388" },
                      "&.MuiInputLabel-shrink": { top: "2px" },
                    }}
                  >
                    User
                  </StyledInputLabel>
                  <StyledSelect
                    labelId="user-label"
                    name="user"
                    className="reporting-select"
                    onChange={(e) => {setFilter({ ...filter, user: e.target.value })}}
                    value={filter?.user || options?.user[0]?.value} 
                    fullWidth
                  >
                    <CustomMenuItem value="">
                      Select a user
                    </CustomMenuItem>
                    {options.user.map((option) => (
                      <CustomMenuItem key={option.key} value={option.value}>
                        {option.label}
                      </CustomMenuItem>
                    ))}
                  </StyledSelect>
                </FormControl>
                </Box>

                {/* Type */}
                <Box sx={{ display: "flex", alignItems: "center", width: "200px"}}>
                <FormControl>
                  <StyledInputLabel
                    id="type-label"
                    sx={{
                      color: "#6B7280",
                      fontFamily: "Nunito",
                      fontSize: "16px",
                      background: "white",
                      padding: "0 5px",
                    }}
                  >
                    Type
                  </StyledInputLabel>
                  <StyledSelect
                    labelId="type-label"
                    name="type"
                    className="reporting-select"
                    onChange={(e) => {setFilter({ ...filter, type: e.target.value })}}
                    value={filter?.type || options?.type[0]?.value}
                  >
                    <CustomMenuItem value="" disabled> Select a type </CustomMenuItem>
                    {options.type.map((option) => (
                      <CustomMenuItem key={option.key} value={option.value}>
                        {option.label}
                      </CustomMenuItem>
                    ))}
                  </StyledSelect>
                  </FormControl>
                </Box>

                {/* From Date */}
                <Box sx={{ display: "flex", alignItems: "center", width: "170px" }}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MemoizedDatePicker
                      label="From"
                      disabled={duration !== "4"}
                      value={parseISO(startDate) || null} 
                      onChange={(newDate) => {
                        if (newDate && !isNaN(newDate)) {
                          handleStartDateChange(format(newDate, "yyyy-MM-dd"))
                        }
                      }}
                      inputFormat="yyyy-MM-dd" 
                      InputLabelProps={{ shrink: true }}
                    />
                  </LocalizationProvider>
                </Box>

                {/* To Date */}
                <Box sx={{ display: "flex", alignItems: "center", width: "170px" }}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MemoizedDatePicker
                      label="To"
                      disabled={duration !== "4"}
                      value={parseISO(endDate) || null} 
                      onChange={(newDate) => {
                        if (newDate && !isNaN(newDate)) {
                          handleEndDateChange(format(newDate, "yyyy-MM-dd"))
                        }
                      }}
                      inputFormat="yyyy-MM-dd"
                      InputLabelProps={{ shrink: true }}
                    />
                  </LocalizationProvider>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <BaseButton
                    buttonText="Run Report"
                    sx={{
                      height: "40px",
                      minWidth: "120px",
                      padding: "5px 15px",
                      fontSize: "14px",
                      lineHeight: "normal", 
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "15px",
                      textTransform: "none",
                    }}
                    onClick={() => {
                      setFetchSummary(true);
                      setShowDetails(false);
                    }}
                  />

                  <Button
                    variant="outlined"
                    sx={{
                      textTransform: "none",
                      fontSize: "14px",
                      color: "#6B7280",
                      borderColor: "#D7D7D7",
                      borderRadius: "5px",
                      padding: "5px 15px",
                      height: "40px",
                      "&:hover": {
                        backgroundColor: "#F5F5F5",
                        borderColor: "#D7D7D7",
                      },
                    }}
                    onClick={clearFilter}
                  >
                    Clear Filter
                  </Button>
                </Box>
              </Box>
            </Box>
          
            <Box className="reporting-container">
              <Box className="reporting-table-header">
                {reportingTitle[duration]}

                <Box sx={{ display: "flex", width: "100%", alignItems: "center", backgroundColor: "#FFFFFF" }}>
                  <Box sx={{flexDirection: "column", width: "50%"}}>
                    <Typography
                      sx={{
                        textAlign: "center", 
                        color: "#000000", 
                        fontFamily: "Nunito", 
                        fontStyle: "normal",
                        fontSize: "25px", 
                        fontWeight: "400", 
                        margin: "0 auto" // center horizontally
                      }}
                    >
                    {
                        isAdmin === "true" ? 
                        "Admin Reports" 
                        : 
                        isOperator === "true" ? 
                        "Operator/Clerk Reports" 
                        :
                        "Agent Reports"
                      }
                    </Typography>

                    {showDetails ? transactionType && <Typography 
                    sx={{ 
                      textAlign: "center", 
                      color: "#6B7280", 
                      fontFamily: "Nunito", 
                      fontStyle: "normal",
                      fontSize: "20px", 
                      fontWeight: "400", 
                      margin: "0 auto" // center horizontally
                    }}
                  >
                    {transactionType[0]?.label || "All Transactions"} - {filter?.user ? (options?.user.find(option => option.value === filter?.user)?.label || "") : options?.user[0]?.label}
                  </Typography>
                :
                <Typography 
                sx={{ 
                  // flex: 1, 
                  textAlign: "center", 
                  color: "#6B7280", 
                  fontFamily: "Nunito", 
                  fontStyle: "normal",
                  fontSize: "20px", 
                  fontWeight: "400", 
                  margin: "0 auto" // center horizontally
                }}
              >
                Summary View - {filter?.user ? (options?.user.find(option => option.value === filter?.user)?.label || "") : options?.user[0]?.label}
              </Typography>
                }

                    <Typography 
                      sx={{ 
                        // flex: 1, 
                        textAlign: "center", 
                        color: "#6B7280", 
                        fontFamily: "Nunito", 
                        fontStyle: "normal",
                        fontSize: "20px", 
                        fontWeight: "400", 
                        margin: "0 auto" // center horizontally
                      }}
                    >
                      {startDate && endDate ? `${startDate} to ${endDate}` : "Select a Date"}
                    </Typography>

                </Box>

                {
                  !showDetails &&
                (
                  <Box sx={{ display: "flex", justifyContent: "flex-end", flexGrow: 1 }}>
                    <Button 
                      variant="contained" 
                      sx={{ 
                        float: "right", 
                        marginTop: "30px", 
                        marginRight: "15px",
                        backgroundColor: '#145388',
                      }}
                      onClick={() => setFilter({...filter, viewAll: true})}
                    >
                      View All
                    </Button>
                  </Box>
                )
                }
              </Box>
            </Box>
              <TableContainer
                thisduration={duration}
                showDetails={showDetails}
                handleDetailSwitch={handleDetailSwitch}
                clearFilter={clearFilter}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                isAdmin={isAdmin}
                userID={agent['User']?.id}
                filter={filter}
                setFilter={setFilter}
                transactionType={transactionType}
                setTransactionType={setTransactionType}
                options={options}
                currency={currency}
                setCurrency={setCurrency}
                isOperator={isOperator}
                fetchSummary={fetchSummary}
                setFetchSummary={setFetchSummary}
              />
            </Box>
          </Box> : selectedReportType == '2' ? 
          <Box>
            <Box sx={{ backgroundColor: "#FFFFFF", padding: "10px", borderRadius: "8px" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "nowrap" }}>
                <Box sx={{ marginRight: "auto"}}>
                  <FormControl fullWidth>
                    <InputLabel
                      id="select-view-label"
                      sx={{
                        color: "#6B7280",
                        fontFamily: "Nunito",
                        fontSize: "16px",
                        background: "white",
                        padding: "0 5px",
                      }}
                    >
                      Select View
                    </InputLabel>
                    <Select
                      labelId="select-view-label"
                      name="selectView"
                      className="reporting-select"
                      onChange={handleLoanDurationChange}
                      value={loansDuration}
                      sx={{
                        borderRadius: "5px", // Custom border radius
                        border: "1px solid #D7D7D7", // Your custom border
                        color: "#6B7280", // Text color
                        fontFamily: "Nunito", // Font family
                        fontSize: "16px", // Font size
                        padding: "0px 10px", // Adjust padding
                        width: "100%", // Width
                        height: "40px", // Height
                        background: "white", // Background color
                        textAlign: "left", // Align text to the left
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none", // Removes the default border applied by Material-UI
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          border: "none", // Ensures no border appears on hover
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "none", // Ensures no border appears on focus
                        },
                      }}
                    >
                      <CustomMenuItem value="" disabled>
                        Reports
                      </CustomMenuItem>
                      <CustomMenuItem value="1">Account Daily</CustomMenuItem>
                      <CustomMenuItem value="2">Account Weekly</CustomMenuItem>
                      <CustomMenuItem value="3">Account Monthly</CustomMenuItem>
                      <CustomMenuItem value="4">Account Custom</CustomMenuItem>
                    </Select>
                  </FormControl>
                </Box>
                {/* User */}
                <Box sx={{ display: "flex", alignItems: "center", width: "200px" }}>
                  <FormControl fullWidth>
                  <StyledInputLabel
                    id="user-label"
                    sx={{
                      color: "#6B7280",
                      fontFamily: "Nunito",
                      fontSize: "16px",
                      background: "white",
                      padding: "0 5px",
                      lineHeight: "1.2", 
                      top: "-4px", 
                      "&.Mui-focused": { color: "#145388" },
                      "&.MuiInputLabel-shrink": { top: "2px" },
                    }}
                  >
                    User
                  </StyledInputLabel>
                  <StyledSelect
                    labelId="user-label"
                    name="user"
                    className="reporting-select"
                    onChange={(e) => {setLoansFilter({ ...loansFilter, user: e.target.value })}}
                    value={loansFilter?.user || options?.user[0]?.value} 
                    fullWidth
                  >
                    <CustomMenuItem value="">
                      Select a user
                    </CustomMenuItem>
                    {options.user.map((option) => (
                      <CustomMenuItem key={option.key} value={option.value}>
                        {option.label}
                      </CustomMenuItem>
                    ))}
                  </StyledSelect>
                </FormControl>
                </Box>

                {/* From Date */}
                <Box sx={{ display: "flex", alignItems: "center", width: "170px" }}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MemoizedDatePicker
                      label="From"
                      disabled={loansDuration !== "4"}
                      value={parseISO(loansStartDate) || null} 
                      onChange={(newDate) => {
                        if (newDate && !isNaN(newDate)) {
                          handleLoanStartDateChange(format(newDate, "yyyy-MM-dd"))
                        }
                      }}
                      inputFormat="yyyy-MM-dd" 
                      InputLabelProps={{ shrink: true }}
                    />
                  </LocalizationProvider>
                </Box>

                {/* To Date */}
                <Box sx={{ display: "flex", alignItems: "center", width: "170px" }}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MemoizedDatePicker
                      label="To"
                      disabled={loansDuration !== "4"}
                      value={parseISO(loansEndDate) || null} 
                      onChange={(newDate) => {
                        if (newDate && !isNaN(newDate)) {
                          handleLoansEndDateChange(format(newDate, "yyyy-MM-dd"))
                        }
                      }}
                      inputFormat="yyyy-MM-dd"
                      InputLabelProps={{ shrink: true }}
                    />
                  </LocalizationProvider>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <BaseButton
                    buttonText="Run Report"
                    sx={{
                      height: "40px",
                      minWidth: "120px",
                      padding: "5px 15px",
                      fontSize: "14px",
                      lineHeight: "normal", 
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "15px",
                      textTransform: "none",
                    }}
                    onClick={() => {
                      setFetchSummary(true);
                      setShowDetails(false);
                    }}
                  />

                  <Button
                    variant="outlined"
                    sx={{
                      textTransform: "none",
                      fontSize: "14px",
                      color: "#6B7280",
                      borderColor: "#D7D7D7",
                      borderRadius: "5px",
                      padding: "5px 15px",
                      height: "40px",
                      "&:hover": {
                        backgroundColor: "#F5F5F5",
                        borderColor: "#D7D7D7",
                      },
                    }}
                    onClick={clearFilter}
                  >
                    Clear Filter
                  </Button>
                </Box>
              </Box>

              <Box className="reporting-container">
                <Box className="reporting-table-header">
                  {reportingTitle[loansDuration]}

                  <Box sx={{ display: "flex", width: "100%", alignItems: "center", backgroundColor: "#FFFFFF" }}>
                    <Box sx={{flexDirection: "column", width: "50%"}}>
                      <Typography
                        sx={{
                          textAlign: "center", 
                          color: "#000000", 
                          fontFamily: "Nunito", 
                          fontStyle: "normal",
                          fontSize: "25px", 
                          fontWeight: "400", 
                          margin: "0 auto" // center horizontally
                        }}
                      >
                        Loan Reports
                      </Typography>
                    </Box>

                    {
                        !showDetails &&
                      (
                        <Box sx={{ display: "flex", justifyContent: "flex-end", flexGrow: 1 }}>
                          <Button 
                            variant="contained" 
                            sx={{ 
                              float: "right", 
                              marginTop: "30px", 
                              marginRight: "15px",
                              backgroundColor: '#145388',
                            }}
                            onClick={() => setLoansFilter({...loansFilter, viewAll: true})}
                          >
                            View All
                          </Button>
                        </Box>
                      )
                    }
                  </Box>
                </Box>

                <TableContainer
                  thisduration={loansDuration}
                  showDetails={showDetails}
                  handleDetailSwitch={handleDetailSwitch}
                  clearFilter={clearFilter}
                  startDate={loansStartDate}
                  setStartDate={setLoansStartDate}
                  endDate={loansEndDate}
                  setEndDate={setLoansEndDate}
                  isAdmin={isAdmin}
                  userID={agent['User']?.id}
                  filter={loansFilter}
                  setFilter={setLoansFilter}
                  transactionType={`6, 18`}
                  setTransactionType={setTransactionType}
                  options={options}
                  currency={currency}
                  setCurrency={setCurrency}
                  isOperator={isOperator}
                  fetchSummary={fetchSummary}
                  setFetchSummary={setFetchSummary}
                  reportType={"Loans"}
                />
              </Box>
            </Box>
          </Box> : selectedReportType == '3' ? 
          <Box>
          <Box sx={{ backgroundColor: "#FFFFFF", padding: "10px", borderRadius: "8px" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "nowrap" }}>
              <Box sx={{ marginRight: "auto"}}>
                <FormControl fullWidth>
                  <InputLabel
                    id="select-view-label"
                    sx={{
                      color: "#6B7280",
                      fontFamily: "Nunito",
                      fontSize: "16px",
                      background: "white",
                      padding: "0 5px",
                    }}
                  >
                    Select View
                  </InputLabel>
                  <Select
                    labelId="select-view-label"
                    name="selectView"
                    className="reporting-select"
                    onChange={handleATMDurationChange}
                    value={ATMDuration}
                    sx={{
                      borderRadius: "5px", // Custom border radius
                      border: "1px solid #D7D7D7", // Your custom border
                      color: "#6B7280", // Text color
                      fontFamily: "Nunito", // Font family
                      fontSize: "16px", // Font size
                      padding: "0px 10px", // Adjust padding
                      width: "100%", // Width
                      height: "40px", // Height
                      background: "white", // Background color
                      textAlign: "left", // Align text to the left
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none", // Removes the default border applied by Material-UI
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        border: "none", // Ensures no border appears on hover
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "none", // Ensures no border appears on focus
                      },
                    }}
                  >
                    <CustomMenuItem value="" disabled>
                      Reports
                    </CustomMenuItem>
                    <CustomMenuItem value="1">Account Daily</CustomMenuItem>
                    <CustomMenuItem value="2">Account Weekly</CustomMenuItem>
                    <CustomMenuItem value="3">Account Monthly</CustomMenuItem>
                    <CustomMenuItem value="4">Account Custom</CustomMenuItem>
                  </Select>
                </FormControl>
              </Box>
              {/* User */}
              <Box sx={{ display: "flex", alignItems: "center", width: "200px" }}>
                <FormControl fullWidth>
                <StyledInputLabel
                  id="user-label"
                  sx={{
                    color: "#6B7280",
                    fontFamily: "Nunito",
                    fontSize: "16px",
                    background: "white",
                    padding: "0 5px",
                    lineHeight: "1.2", 
                    top: "-4px", 
                    "&.Mui-focused": { color: "#145388" },
                    "&.MuiInputLabel-shrink": { top: "2px" },
                  }}
                >
                  User
                </StyledInputLabel>
                <StyledSelect
                  labelId="user-label"
                  name="user"
                  className="reporting-select"
                  onChange={(e) => {setATMFilter({ ...atmFilter, user: e.target.value })}}
                  value={atmFilter?.user || options?.type[0]?.value} 
                  fullWidth
                >
                  <CustomMenuItem value="">
                    Select an ATM
                  </CustomMenuItem>
                  {atmOptions?.user?.map((option) => (
                    <CustomMenuItem key={option.key} value={option.value}>
                      {option.label}
                    </CustomMenuItem>
                  ))}
                </StyledSelect>
              </FormControl>
              </Box>

              {/* Type */}
              <Box sx={{ display: "flex", alignItems: "center", width: "200px"}}>
                <FormControl>
                  <StyledInputLabel
                    id="type-label"
                    sx={{
                      color: "#6B7280",
                      fontFamily: "Nunito",
                      fontSize: "16px",
                      background: "white",
                      padding: "0 5px",
                    }}
                  >
                    Type
                  </StyledInputLabel>
                  <StyledSelect
                    labelId="type-label"
                    name="type"
                    className="reporting-select"
                    onChange={(e) => {setATMFilter({ ...atmFilter, type: e.target.value })}}
                    value={atmFilter?.type || options?.type[0]?.value}
                  >
                    <CustomMenuItem value="" disabled> Select a type </CustomMenuItem>
                    {atmOptions.type.map((option) => (
                      <CustomMenuItem key={option.key} value={option.value}>
                        {option.label}
                      </CustomMenuItem>
                    ))}
                  </StyledSelect>
                  </FormControl>
                </Box>

              {/* From Date */}
              <Box sx={{ display: "flex", alignItems: "center", width: "170px" }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <MemoizedDatePicker
                    label="From"
                    disabled={ATMDuration !== "4"}
                    value={parseISO(atmStartDate) || null} 
                    onChange={(newDate) => {
                      if (newDate && !isNaN(newDate)) {
                        handleATMStartDateChange(format(newDate, "yyyy-MM-dd"))
                      }
                    }}
                    inputFormat="yyyy-MM-dd" 
                    InputLabelProps={{ shrink: true }}
                  />
                </LocalizationProvider>
              </Box>

              {/* To Date */}
              <Box sx={{ display: "flex", alignItems: "center", width: "170px" }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <MemoizedDatePicker
                    label="To"
                    disabled={ATMDuration !== "4"}
                    value={parseISO(atmEndDate) || null} 
                    onChange={(newDate) => {
                      if (newDate && !isNaN(newDate)) {
                        handleATMEndDateChange(format(newDate, "yyyy-MM-dd"))
                      }
                    }}
                    inputFormat="yyyy-MM-dd"
                    InputLabelProps={{ shrink: true }}
                  />
                </LocalizationProvider>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <BaseButton
                  buttonText="Run Report"
                  sx={{
                    height: "40px",
                    minWidth: "120px",
                    padding: "5px 15px",
                    fontSize: "14px",
                    lineHeight: "normal", 
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "15px",
                    textTransform: "none",
                  }}
                  onClick={() => {
                    setFetchSummary(true);
                    setShowDetails(false);
                  }}
                />

                <Button
                  variant="outlined"
                  sx={{
                    textTransform: "none",
                    fontSize: "14px",
                    color: "#6B7280",
                    borderColor: "#D7D7D7",
                    borderRadius: "5px",
                    padding: "5px 15px",
                    height: "40px",
                    "&:hover": {
                      backgroundColor: "#F5F5F5",
                      borderColor: "#D7D7D7",
                    },
                  }}
                  onClick={clearFilter}
                >
                  Clear Filter
                </Button>
              </Box>
            </Box>

            <Box className="reporting-container">
              <Box className="reporting-table-header">
                {reportingTitle[ATMDuration]}

                <Box sx={{ display: "flex", width: "100%", alignItems: "center", backgroundColor: "#FFFFFF" }}>
                  <Box sx={{flexDirection: "column", width: "50%"}}>
                    <Typography
                      sx={{
                        textAlign: "center", 
                        color: "#000000", 
                        fontFamily: "Nunito", 
                        fontStyle: "normal",
                        fontSize: "25px", 
                        fontWeight: "400", 
                        margin: "0 auto" // center horizontally
                      }}
                    >
                      ATM Reports
                    </Typography>
                  </Box>

                  {
                      !showDetails &&
                    (
                      <Box sx={{ display: "flex", justifyContent: "flex-end", flexGrow: 1 }}>
                        <Button 
                          variant="contained" 
                          sx={{ 
                            float: "right", 
                            marginTop: "30px", 
                            marginRight: "15px",
                            backgroundColor: '#145388',
                          }}
                          onClick={() => setATMFilter({...atmFilter, viewAll: true})}
                        >
                          View All
                        </Button>
                      </Box>
                    )
                  }
                </Box>
              </Box>

              <TableContainer
                thisduration={ATMDuration}
                showDetails={showDetails}
                handleDetailSwitch={handleDetailSwitch}
                clearFilter={clearFilter}
                startDate={atmStartDate}
                setStartDate={setATMStartDate}
                endDate={atmEndDate}
                setEndDate={setATMEndDate}
                isAdmin={isAdmin}
                userID={agent['User']?.id}
                filter={atmFilter}
                setFilter={setATMFilter}
                transactionType={transactionType}
                setTransactionType={setTransactionType}
                options={options}
                currency={currency}
                setCurrency={setCurrency}
                isOperator={isOperator}
                fetchSummary={fetchSummary}
                setFetchSummary={setFetchSummary}
                reportType={"ATM"}
              />
            </Box>
          </Box>
        </Box> :
          null
        }

    </Box>
  </Box>
  );
}

export default Reporting;
